export default __webpack_public_path__ + "static/media/banner-home_compress.c0e17488.webp";